import ItemWithBadges from '~/components/dashboard/soapV2/collapsibleRail/summary/ItemWithBadges'
import type { Order } from '~/types'
import TaskOrderActions from '~/utils/actions/TaskOrderActions'

export interface TaskOrderProps {
  data: Order
}

const TaskOrder = ({ data, ...rest }: TaskOrderProps) => (
  <ItemWithBadges
    actions={<TaskOrderActions order={data} {...rest} />}
    order={data}
  />
)

export default TaskOrder
